import request from 'helpers/request';
import api from 'config';

export const HolidayCompanyInfoList = (year) =>
  request({
    url: `${api.config.companyAPI}/company/v1/holidays/${year}`
  });

export const HolidayCompanyInfo = (holidayIdx) =>
  request({
    url: `${api.config.companyAPI}/company/v1/holiday/${holidayIdx}`
  });

export const HolidayCompanySave = (data) =>
  request({
    method: 'POST',
    data,
    url: `${api.config.companyAPI}/company/v1/holidays`
  });
